import React from "react";
import {
	Box,
	Typography,
	Paper,
	List,
	ListItem,
	ListItemText,
	Alert,
} from "@mui/material";
import farmstand from "../../Images/farmstand.jpg";

const TheFarmstand = () => (
	<Box sx={{ maxWidth: 700, mx: "auto", mt: 4, p: 2 }}>
		{
			//get the date and if its after October 31st show the alert
			new Date() > new Date(new Date().getFullYear(), 9, 31) && (
				<Alert severity="error" sx={{ mb: 2 }}>
					<strong>Note:</strong> The farmstand is closed for the season and will
					reopen in May {new Date().getFullYear() + 1}.
				</Alert>
			)
		}
		<Paper sx={{ p: 3 }}>
			<Typography variant="h4" gutterBottom>
				Gosell Gardens Farmstand FAQ
			</Typography>
			<Typography variant="h6" gutterBottom>
				About Our Farmstand
			</Typography>
			<Typography paragraph>
				Gosell Gardens Farmstand is a local, family-run stand offering fresh
				eggs, seasonal produce, and some homemade goods. We are committed to
				sustainable practices and providing our community with healthy,
				delicious food straight from our garden and flock.
			</Typography>
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				gap={2}
				mt={2}
				mb={2}
			>
				<Box>
					<img
						src={farmstand}
						alt="Gosell Gardens Farmstand"
						style={{
							width: "100%",
							maxWidth: 600,
							borderRadius: 12,
							objectFit: "cover",
							boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
						}}
						loading="lazy"
					/>
				</Box>
			</Box>
			<Typography variant="h6" gutterBottom>
				How to Buy
			</Typography>
			<List>
				<ListItem>
					<ListItemText
						primary="Visit Us"
						secondary="Stop by our farmstand 8am to dusk May to October. Our farmstand is cash only, self service and first come first serve."
					/>
				</ListItem>
				<ListItem>
					<ListItemText
						primary="Egg Requests"
						secondary="Sign up for our egg request list to request eggs online. You’ll be notified when your order is ready for pickup. You can also just stop by to see if we have any eggs available."
					/>
				</ListItem>
				<ListItem>
					<ListItemText
						primary="Produce & Goods"
						secondary="Seasonal produce and homemade items are available on a first-come, first-served basis. Raspberries, Blueberries, Veggies and more when in season!"
					/>
				</ListItem>
			</List>
			<Typography variant="h6" gutterBottom>
				Details & Hours
			</Typography>
			<Typography paragraph>
				<b>Location:</b> Gosell Gardens Farmstand, 9226 Old Concord Blvd, Inver
				Grove Heights MN 55076
				<br />
				<b>Hours:</b> 8am to dusk, May to October
				<br />
				<b>Contact:</b> connor@gosellgardens.com
			</Typography>
			<Typography variant="h6" gutterBottom>
				Additional Info
			</Typography>
			<Typography paragraph>
				Please bring your own bags or cartons if possible. Follow us on social
				media for updates on what’s fresh and available each week!
			</Typography>
			<Typography variant="body2" color="textSecondary">
				Note: the farmstand is not staffed and is a help-yourself style. If you
				want to set an appointent to meet with the team, please email us or stop
				by during our regular business hours, which vary seasonally.
			</Typography>
		</Paper>
	</Box>
);

export default TheFarmstand;
